import request from '../../axios/axiosconfig.js'

/**
 * 查询订单运维列表
 * @param {*} params 
 * @returns 
 */
export function getOamRecord(params) {
  return request({
    url: '/ps/oam/getOamRecord',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/oder/operationrecord.js